// Author THQ
// Date 2025-03-09 10:14:29

class PpeApplyRecordDetail {
constructor({
        id = null,
        flowId = '',
        inventoryId = '',
        itemType = '',
        itemName = '',
        itemModel = '',
        itemUnit = '',
        originalQuantity = '',
        applyQuantity = '',
        remark = ''}
= {}) {
    this.id = id;
    this.flowId = flowId;
    this.inventoryId = inventoryId;
    this.itemType = itemType;
    this.itemName = itemName;
    this.itemModel = itemModel;
    this.itemUnit = itemUnit;
    this.originalQuantity = originalQuantity;
    this.applyQuantity = applyQuantity;
    this.remark = remark;
}
}

function newEntity() {
return new PpeApplyRecordDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'flowId',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.flowId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'inventoryId',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.inventoryId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemType',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.itemType',
        sortable: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_material_type'
                        }
        },
        {
        key: 'itemName',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.itemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemModel',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.itemModel',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.itemUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'originalQuantity',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.originalQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyQuantity',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.applyQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyRecordDetail.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    flowIdFilter : '',
    inventoryIdFilter : '',
    itemTypeFilter : '',
    itemNameFilter : '',
    itemModelFilter : '',
    itemUnitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'flowIdFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.flowId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppeApplyRecord'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inventoryIdFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.inventoryId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppeInventory'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'itemTypeFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.itemType',
        disabled: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_material_type'
                }
        },
        {
        key: 'itemNameFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.itemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemModelFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.itemModel',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemUnitFilter',
        label: 'label.em.ppe.ppeApplyRecordDetail.filter.itemUnit',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'flowId',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.flowId',
        sortable: true,
        isDetail: true,
        disabled: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppeApplyRecord'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inventoryId',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.inventoryId',
        sortable: true,
        isDetail: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemType',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.itemType',
        sortable: true,
        disabled: true,
        form: {
        type: 'dictEnumSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'ppe_material_type'
                }
        },
        {
        key: 'itemName',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.itemName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'ppeInventory'
            ,correspondingField: 'itemName'
            ,fieldsBindingByEntityModalSelected: '{"inventoryId":"id","itemModel":"itemModel","itemUnit":"itemUnit","originalQuantity":"quantity","itemType":"itemType"}'
                }
        },
        {
        key: 'itemModel',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.itemModel',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.itemUnit',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'originalQuantity',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.originalQuantity',
        sortable: true,
        disabled: true,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyQuantity',
        label: 'label.em.ppe.ppeApplyRecordDetail.entity.applyQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
]

export {PpeApplyRecordDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
